export default "__VITE_ASSET__D1riqN9h__"